export default function Footer() {
  return (
    <footer className="bg-dark text-white text-center py-4 mt-5">
      <div className="container">
        <p className="mb-1 fw-bold">© 2025 TEDxSetapak</p>
        <small>
          This independent TEDx event is operated under license from TED.
        </small>
      </div>
    </footer>
  );
}
